import { useStore } from 'vuex';
import { TAB_PRODUCTS } from '@maison/helpers/search-helper';
import AlgoliaSearch from '@maison/search/algolia/AlgoliaSearch';

export const useSearchPanelResults = () => {
  const store = useStore();

  const hasFilters = (tab) => tab === TAB_PRODUCTS && AlgoliaSearch.isEnabled();

  const onTabChange = async (tab) => {
    await store.dispatch('search/changeCurrentTab', tab);
  };

  return {
    hasFilters,
    onTabChange,
  };
};
